// Components==============
import { faFile, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import indexGroups from 'actions/group/index';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './index.module.scss';
// =========================

function Group({ group }) {
    const folders = useSelector((state) =>
        state.group.entities.allIds.map((i) => state.group.entities.byId[i])
    );

    const [count, setCount] = useState(group?.files?.length || 0);

    useEffect(() => {
        const getCount = (parentId) => {
            folders
                .filter((folder) => folder?.parent_id === parentId)
                .forEach((folder) => {
                    setCount((prev) => prev + (folder?.files?.length || 0));
                    getCount(folder.id);
                });

            return count;
        };

        getCount(group.id);
    }, [folders?.length]);

    return (
        <NavLink to={`/group/${group.id}`}>
            <motion.div
                styleName="group"
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
            >
                <h3>{group.name}</h3>
                <div styleName="bottom">
                    <div>
                        <FontAwesomeIcon icon={faFile} />
                        <p>{count}</p>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faUser} />
                        <p>{group?.users?.length}</p>
                    </div>
                </div>
            </motion.div>
        </NavLink>
    );
}

export default function Groups() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexGroups());
    }, [dispatch]);

    const groups = useSelector((state) =>
        state.group.entities.allIds
            .map((id) => state.group.entities.byId[id])
            ?.filter((group) => !group.parent_id)
    );

    return (
        <div styleName="wrapper">
            {groups.map((group, i) => (
                <Group group={group} key={i} />
            ))}
        </div>
    );
}
